import { Reducer } from 'redux';

// Define the Question type
export interface Avatar {
  id: number;
  text: string;
}

const initialState: Avatar[] = [];

const levelImageReducer: Reducer<Avatar[], any> = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LEVEL_IMAGE':
      return action.payload;
    default:
      return state;
  }
};

export default levelImageReducer;
